import { z } from "zod";

import { RateSchema } from "@/types/schemas/rate";
import { LocationSchema } from "./locations";

export const PositionSchema = z.object({
  name: z.string(),
  description: z.string(),
  gifted_hours: z.number().default(4),
  billing_rate: RateSchema,
  supervisory: z.boolean().default(false).optional(),
});

export const InviteStatusSchema = z.enum(["QUEUED", "ACCEPTED", "INVITED", "VIEWED", "DECLINED"]).default("QUEUED");

export const ShiftPosition = z
  .object({
    required: z.boolean().default(true).optional(),
    quantity: z.number().min(1).max(Infinity),
    preferred_quantity: z.number().min(1).max(Infinity).optional(),
    location: LocationSchema.optional(),
    start_time: z.date().optional(),
    invited_users: z.array(
      z.object({
        id: z.string(),
        status: InviteStatusSchema,
        message: z.string().max(120).optional(),
      }),
    ),
  })
  .merge(PositionSchema);

export const PositionsSchema = z
  .object({
    $schema: z.string().optional(),
  })
  .catchall(PositionSchema)
  .default({
    stagehand_1: {
      name: "Stagehand",
      description: "General labor for stage setup and teardown.",
      billing_rate: {
        rate: 35.0,
        unit: "hour",
      },
    },
    lighting_tech_1: {
      name: "Lighting Technician",
      description: "Responsible for setting up and operating lighting equipment.",
      billing_rate: {
        rate: 55.0,
        unit: "hour",
      },
    },
    sound_engineer_1: {
      name: "Sound Engineer",
      description: "Manages audio mixing and sound reinforcement.",
      billing_rate: {
        rate: 65.0,
        unit: "hour",
      },
    },
    production_manager_1: {
      name: "Production Manager",
      description: "Oversees all technical aspects of a production.",
      billing_rate: {
        rate: 80.0,
        unit: "hour",
      },
    },
  });
